(function() { window.GUID_f8ffc9eb_9d7b_49b8_b862_da212cb6e918 = { getGuid: function() { return "f8ffc9eb-9d7b-49b8-b862-da212cb6e918"; } }; })();
var CS;
(function (CS) {
    CS.SetCalendarRegionalSettings();
    class Calendar {
        constructor(inputBox, isCalendarPicker) {
            this.SelectionChange = null;
            this.isCalendarPicker = isCalendarPicker;
            this.uiDiscovery(inputBox);
            this.bindEvent();
        }
        uiDiscovery(inputBox) {
            if (!this.isCalendarPicker) {
                this.yearRange = "-100:+5";
            }
            else {
                this.yearRange = undefined;
            }
            this.InputBox = inputBox;
            this.InputBox.data('context', this);
            this.DatePickerId = inputBox[0].id;
            this.DatePickerHiddenId = this.DatePickerId + "Hidden";
            this.hiddenValue = $("#" + this.DatePickerHiddenId);
            this.CSDatePicker = inputBox.datepicker({
                changeMonth: true,
                changeYear: true,
                numberOfMonths: 1,
                yearRange: this.yearRange,
                altField: "#" + this.DatePickerHiddenId, // invariant ISO field
                altFormat: "yy-mm-dd",
                beforeShowDay: function (d) {
                    //ScheduleDates vient de la des vues qui applique JSArrayHelper 
                    if (typeof ScheduledDates !== 'undefined' && ScheduledDates != null) {
                        var year = d.getFullYear();
                        var month = d.getMonth() + 1;
                        var day = d.getDate();
                        if (month.toString().length == 1) {
                            month = '0' + month;
                        }
                        if (day.toString().length == 1) {
                            day = '0' + day;
                        }
                        var result = year + '-' + month + '-' + day;
                        if ($.inArray(result, ScheduledDates) != -1) {
                            //[0] = true/false (isEnable or not                //[1] = CSS class                //[2] = tooltip
                            return [true, "HighlightedDayDatePicker", "Available"];
                        }
                        else {
                            return [true, "NotHighlightedDayDatePicker", "unAvailable"];
                        }
                    }
                    else {
                        return [true, "NotHighlightedDayDatePicker", "unAvailable"];
                    }
                },
                showButtonPanel: !this.isCalendarPicker
            });
            if (this.isCalendarPicker) {
                const dataSelectedDate = this.InputBox.data('selecteddate');
                this.defaultStartDate = Calendar.ParseISODate(dataSelectedDate);
                this.CSDatePicker.datepicker('setDate', this.defaultStartDate);
            }
            else {
                this.CSDatePicker.datepicker('setDate', Calendar.ParseISODate(this.hiddenValue.val()));
            }
            this.ActualSelectedDate = this.CSDatePicker.datepicker('getDate');
        }
        bindEvent() {
            let me = this;
            this.InputBox.on('keyup', function (e) {
                if (e.keyCode == 13) {
                    me.InputBox.trigger('blur');
                }
            }).on('change', function () {
                let newStartDate = me.CSDatePicker.datepicker('getDate');
                if (newStartDate != null && (me.ActualSelectedDate == null || newStartDate.toString() != me.ActualSelectedDate.toString()) || me.isCalendarPicker) {
                    if (me.ActualSelectedDate != null) {
                        var diffYear = me.ActualSelectedDate.getFullYear() - newStartDate.getFullYear();
                        var diffMonth = me.ActualSelectedDate.getMonth() - newStartDate.getMonth();
                        var diffDay = me.ActualSelectedDate.getDate() - newStartDate.getDate();
                        me.OffsetYear = diffYear;
                        me.OffsetMonth = diffMonth;
                        me.OffsetDay = diffDay;
                    }
                    else {
                        me.OffsetYear = 0;
                        me.OffsetMonth = 0;
                        me.OffsetDay = 0;
                    }
                    me.ActualSelectedDate = newStartDate;
                    //me.hiddenValue.val($.datepicker.formatDate('yy-mm-dd', me.ActualSelectedDate));
                    if (me.SelectionChange != null) {
                        me.SelectionChange.call(me);
                    }
                    me.InputBox.trigger("CSChange", me);
                    if (!me.isCalendarPicker) {
                        $('.DummyInput').focus();
                    }
                }
                else if (newStartDate == null && me.ActualSelectedDate != null) {
                    me.hiddenValue.val('');
                    me.CSDatePicker.datepicker('setDate', null);
                    me.ActualSelectedDate = newStartDate;
                    if (me.SelectionChange != null) {
                        me.SelectionChange.call(me);
                    }
                    me.InputBox.trigger("CSChange", me);
                }
            });
        }
        val(newVal) {
            if (newVal != null) {
                let newValDate;
                if (typeof newVal === 'string' || newVal instanceof String)
                    newValDate = Calendar.ParseISODate(newVal);
                else
                    newValDate = newVal;
                this.InputBox.datepicker('setDate', newValDate);
                this.InputBox.trigger('change');
            }
            else {
                var dateTypeVar = this.InputBox.datepicker('getDate');
                return $.datepicker.formatDate('yy-mm-dd', dateTypeVar);
            }
        }
        static ParseISODate(isoDateString) {
            if (isoDateString == null || isoDateString === "") {
                return undefined;
            }
            var dateString = isoDateString.toString().substring(0, 10);
            if (dateString.length < 10) {
                return undefined;
            }
            try {
                return $.datepicker.parseDate("yy-mm-dd", dateString);
            }
            catch (e) {
                return undefined;
            }
        }
    }
    CS.Calendar = Calendar;
})(CS || (CS = {}));

//# sourceMappingURL=cs.calendar.js.map
